export default {
  default: {
    title: 'Widget niet gevonden',
    description:
      'De widget is niet gevonden in de widgetcollectie. Het lijkt erop dat een van onze ontwikkelaars iets te veel mede heeft gedronken. We lossen het snel op...',
    header: 'Oeps...'
  },
  nextSteps: {
    title: 'Volgende stappen',
    description: 'Hier zijn de volgende 5 stappen voor alle batches',
    header: 'Aankomende stappen'
  },
  calendar: {
    title: 'Kalender',
    description: 'Kalender',
    header: 'Kalender'
  },
  batchOverview: {
    title: 'Batchoverzicht',
    description: 'Overzicht van actieve en geplande batches',
    header: 'Batchoverzicht',
    startBrewing: 'Begin met brouwen',
    active: 'Actief',
    planned: 'Gepland',
    noBrews: 'Geen brouwsels'
  },
  tilts: {
    title: 'Tilts',
    description: 'Tilt-metingen',
    header: 'Tilts'
  },
  ispindels: {
    title: 'iSpindels',
    description: 'iSpindel-metingen',
    header: 'iSpindels'
  },
  board: {
    empty: 'Geen statistieken beschikbaar',
    itemDefaultHeader: 'Borditem titel',
    itemDefaultContent: 'Borditem inhoud'
  }
};
